module.exports = __webpack_public_path__ + "img/offeo-3.e7f8946b.png";